<template>
  <div>
    <div class="title">지금 입장!</div>
    <div v-if="isWaitingNumber" class="waiting-number" :class="[{
      overflow: enterItem.waitSequenceStatic > 999,
      noPhone: !enterItem.guest.phone
    }]">
      {{ enterItem ? enterItem.waitSequenceStatic : '' }}
    </div>
    <div v-if="!!enterItem.guest.phone" class="phone-number" :class="{ noWaitingNumber: !isWaitingNumber }">
      <img src="../../assets/phone.svg" />{{ enterItem.guest.phone.slice(-4) }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['enter-item', 'is-waiting-number'],
  name: 'entrancePopup'
}
</script>

<style lang="scss" scoped>
@import "@/css/style.scss";
.title {
  font-size: 40px;
  font-weight: $bold;
  color: $gray_800;
  padding: 32px 0 28px;

  @include fhd_combo {
    font-size: 60px;
    padding: 48px 0 42px;
  }

  @include qhd_combo {
    font-size: 80px;
    padding: 64px 0 56px;
  }
}

.waiting-number {
  color: $orange;
  font-weight: $bold;
  font-size: 213px;
  padding: 39px 0 16px;

  @include fhd_combo {
    font-size: 320px;
    padding: 58px 0 24px;
  }

  @include qhd_combo {
    font-size: 380px;
    padding: 77px 0 32px;
  }

  &.overflow {
    font-size: 160px;
    line-height: 160%;

    @include fhd_combo {
      font-size: 240px;
    }

    @include qhd_combo {
      font-size: 300px;
      line-height: 160%;
    }
  }

  &.noPhone {
    padding: 100px 0 146px;

    @include fhd_combo {
      padding: 151px 0 226px;
    }

    @include qhd_combo {
      padding: 220px 0 315px;
    }
  }
}

.phone-number {
  display: flex;
  align-items: center;
  font-size: 64px;
  font-weight: $bold;
  color: $gray_800;
  background: $gray_200;
  padding: 14px 30px 14px 27px;
  border: 2px solid $gray_300;
  border-radius: 24px;

  &.noWaitingNumber {
    margin-top: 40%;
  }

  @include fhd_combo {
    font-size: 96px;
    padding: 21px 45px 21px 41px;
    border: 3px solid $gray_300;
    border-radius: 36px;
  }

  @include qhd_combo {
    font-size: 128px;
    padding: 32px 64px 32px 48px;
    border: 4px solid $gray_300;
    border-radius: 48px;
  }

  img {
    width: 55px;
    height: 55px;
    margin: 0 21px 0 0;

    @include fhd_combo {
      width: 82px;
      height: 82px;
      margin: 0 31px 0 0;
    }
    @include qhd_combo {
      width: 109px;
      height: 109px;
      margin: 0 41px 0 0;
    }
  }
}
</style>
